module.exports = __webpack_public_path__ + "static/media/note-taker.829708a6.png";